import { useFormApi } from '@data-driven-forms/react-form-renderer';

import StackComponent from '~/common/components/Stacks/Stack';

type StackProps = {
  fields?: any[];
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  spacing?: string | number;
  sx?: any;
  children?: React.ReactNode;
};

export default function Stack({
  fields = [],
  direction,
  spacing,
  sx,
  children,
}: Readonly<StackProps>) {
  const { renderForm } = useFormApi();

  return (
    <StackComponent direction={direction} spacing={spacing} sx={sx}>
      {children ?? renderForm(fields)}
    </StackComponent>
  );
}
